import React from "react";
import type { ISvgProps } from "components/icons/shared_props";

import { MAIN_THEME } from "styles/theme";

export default function MinusCircle({
  size = MAIN_THEME.iconSize.small,
  color = MAIN_THEME.colors.brandGray30,
}: ISvgProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 0.296875C4.64844 0.296875 0.3125 4.41602 0.3125 9.5C0.3125 14.584 4.64844 18.7031 10 18.7031C15.3516 18.7031 19.6875 14.584 19.6875 9.5C19.6875 4.41602 15.3516 0.296875 10 0.296875ZM4.84375 10.9844C4.58594 10.9844 4.375 10.784 4.375 10.5391V8.46094C4.375 8.21602 4.58594 8.01562 4.84375 8.01562H15.1562C15.4141 8.01562 15.625 8.21602 15.625 8.46094V10.5391C15.625 10.784 15.4141 10.9844 15.1562 10.9844H4.84375Z"
        fill={color}
      />
    </svg>
  );
}
